import { React, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import "../pages/Contact.css";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import { formValidator } from "../FormValidator";
import { Helmet } from "react-helmet-async";
let modalComponents = [];

const Contact = (props) => {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

  const [loading, setLoading] = useState(false);

  const formRef = useRef();
  const [countryCodes, setCountryCodes] = useState([]);
  const [error, setError] = useState();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    code: "US",
    country: "United States ",
    codeNumber: "+1",
    phoneNumber: "",
    website: "",
    projectTitle: "",
    projectBudget: "",
    projectDesc: "",
    services: [],
    createDateTime: "",
    notAgreeToTerms: true,

    isRequired: [
      "name",
      "email",
      "projectTitle",
      "projectBudget",
      "notAgreeToTerms",
    ],
  });
  const budgets = [
    "5,000 - 8,000 USD",
    "8,000 - 15,000 USD",
    "15,000 - 25,000 USD",
    "25,000 - 40,000 USD",
    "+40,000 USD",
  ];

  function toogleSelect(e) {
    const mainComp = e.target.parentElement.querySelector(".select");
    mainComp?.classList.toggle("open");

    const content = mainComp?.parentElement.querySelector(
      ".custom-select-content",
    );
    content.classList.toggle("open");

    if (content.classList.contains("open")) {
      const inputComp = mainComp?.getElementsByTagName("input")[0];
      inputComp.focus();
      modalComponents.push(e.target);
    }
  }

  function handleSelectClick(e, name, value) {
    const inputComp =
      e.target.parentElement.parentElement.getElementsByTagName("input")[0];
    inputComp.value = value;

    setFormData((prevState) => ({
      ...prevState, // Copy all other key-value pairs
      [name]: value, // Update the specific field that changed
    }));
  }

  function hideSelectContent(e) {
    for (let i = 0; i < modalComponents.length; i++) {
      modalComponents[i].classList.remove("open");
      modalComponents[i].parentElement
        .querySelector(".custom-select-content")
        .classList.remove("open");
    }
    modalComponents.length = 0;

    if (e.target.required == true) {
      setTimeout(() => {
        if (e.target.value == "") e.target.parentElement.classList.add("error");
        else e.target.parentElement.classList.remove("error");
      }, 100);
    }
  }

  function handleCodeClick(e) {
    const inputComp = e.target.parentElement.getElementsByTagName("input");

    inputComp.value = e.target.getAttribute("data-code");

    setFormData((prevState) => ({
      ...prevState,
      ["code"]: e.target.getAttribute("data-code"),
      ["codeNumber"]: e.target.getAttribute("data-number"),
      ["country"]: e.target.getAttribute("data-country"),
    }));

    let flagBgX = -1;
    let z = 0;

    const dvs = e.target.parentElement.parentElement.querySelectorAll(
      ".custom-select-content div",
    );
    dvs.forEach((child) => {
      if (
        e.target.getAttribute("data-code") == child.getAttribute("data-code") &&
        flagBgX == -1
      )
        flagBgX = -45 * z;
      z++;
    });
    e.target.classList.add("active");
    $(".flags").css("background-position-x", flagBgX);
  }

  function handleInputChange(e) {
    let { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState, // Copy all other key-value pairs
      [name]: value, // Update the specific field that changed
    }));
  }

  function handleCheckboxEvent(e) {


    const component = e.currentTarget;

    const isMultiple =
      component.parentElement?.getAttribute("data-multiple") === "true";

    const newValue = component.textContent.trim();

    if (isMultiple) {
      const stateName = component.parentElement.id;

      if (!stateName) return;

      setFormData((prev) => {
        const currentValues = Array.isArray(prev[stateName])
          ? prev[stateName]
          : [];

        return {
          ...prev,
          [stateName]: currentValues.includes(newValue)
            ? currentValues.filter((item) => item !== newValue)
            : [...currentValues, newValue],
        };
      });
    } else {
      const stateName = component.id;

      if (!stateName) return;

      setFormData((prev) => ({
        ...prev,
        [stateName]: !prev[stateName],
      }));
    }

    component.classList.toggle("checked");


    // const component = e.target;
    // let isChecked =
    //   component.classList.toString().indexOf("checked") > -1 ? true : false;

    // component.classList.toggle("checked");

    // let newValue = component.innerHTML;

    // if (component.parentElement.getAttribute("data-multiple") == "true") {
    //   let stateName = component.parentElement.id;
    //   let index = eval("formData." + stateName).indexOf(newValue);
    //   let updatedServices =
    //     index > -1
    //       ? eval("formData." + stateName).splice(index, 1)
    //       : eval("formData." + stateName).push(newValue);
    //   setFormData((prevState) => ({
    //     ...prevState, // Copy all other key-value pairs
    //     [stateName]: eval("formData." + stateName), // Update the specific field that changed
    //   }));
    // } else {
    //   console.log(component.id, isChecked);
    //   setFormData((prevState) => ({
    //     ...prevState, // Copy all other key-value pairs
    //     [component.id]: isChecked, // Update the specific field that changed
    //   }));
    // }
  }

  async function handleFormSubmission(e) {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    e.target.querySelector("button").innerHTML =
      "<div>Sending Request...<i className='progress' /></div>";

    e.target.querySelector("button").disabled = true;

    try {
      // await new Promise((resolve) => {
      //   window.grecaptcha.ready(resolve);
      // });

      // const token = await window.grecaptcha.execute(siteKey, {
      //   action: "lead_submit",
      // });

      let customFormData = formData;
      customFormData.serviceString = formData.services
        .toString()
        .split(",")
        .join(", ");
      let words = formData.name.toString().split(" ");
      const name = words
        .map((word) => {
          if (word.length > 0)
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

          return word;
        })
        .toString()
        .split(",")
        .join(" ");
      customFormData.name = name;
      // customFormData.recaptchaToken = token;


      const now = new Date();
      let currentTime = now.toLocaleTimeString([], { hour12: false });
      let currentDate =
        now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
      customFormData.createDateTime = currentDate + "T" + currentTime;


      console.log(customFormData);

      const response = await fetch(
        "https://hook.us2.make.com/jbvs2wvnhn7mrm3sdae77o77r391dshh",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "x-make-apikey": "R0bust!k@p!key",
            "x-make-apikey": "R0bust!k@p!key",
          },
          body: JSON.stringify(customFormData),
        },
      );

      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      console.log("Response: ", data);
      document.querySelector("#anchorThankYou").click();
      e.target.querySelector("button").disabled = false;

      console.log(customFormData);
    } catch (error) {
      console.log("Fetch Error: ", error.message);
    }
  }

  function checkValidation(e) {
    let checkSpecific = "checkNothing";

    if (e != undefined) {
      checkSpecific =
        "check" +
        e.target.name.charAt(0).toUpperCase() +
        e.target.name.slice(1);
    }

    const [errors, isValid] = formValidator(formData, checkSpecific);
    $("#formSubmitBtn").attr("disabled", !isValid);

    if (errors.length > 0) e.target.parentElement.classList.add("error");
    else if (e != undefined) e.target.parentElement.classList.remove("error");
  }

  useEffect(() => {
    const fc = formRef.current.querySelectorAll("input");
    let check = true;
    // for (const input of fc) if (document.activeElement === input) check = false;
    // if (check) {
    //   checkValidation();
    // }
    checkValidation()
  }, [formData]);

  // Fetching Country Codes from API
  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        setCountryCodes(await response.json());
      } catch (err) {
        console.log("Catch:" + err);
      }
    };
    fetchData("/assets/js/country-codes.json");

    const fetchIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org/?format=json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const userIP = data.ip;

        try {
          const response = await fetch("https://ipinfo.io/" + userIP + "/json");
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await response.json();

          $("#selectCode")
            .parent()
            .find(".custom-select-content div")
            .each(function () {
              if ($(this).data("code").split(" ")[0] == data.country) {
                $(this).trigger("click");
              }
            });
        } catch (err) {
          setError(err.message);
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchIp();
  }, []);

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://robustik.com/contact" />
      </Helmet>
      <section className="hero contact">
        <div className="container">
          <div className="hh1" data-aos="fade-left" data-aos-delay="200">
            We are always{" "}
            <span className="text-primary font-semibold">
              ready to help you{" "}
            </span>
            and answer your questions.
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="flex flex-wrap -mx-10">
            <div
              className="w-full xl:w-1/3 2xl:w-2/5 px-10"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="sticky top-50">
                <div className="hh2">Let's Connect</div>
                <div className="xl:w-4/5 mt-10 fs-20">
                  Let's talk about your next big idea. Use the form to tell us
                  more, or simply drop us an email at{" "}
                  <a
                    href="mailto:contact@robustik.com"
                    className="fs-20 native"
                  >
                    contact@robustik.com
                  </a>
                </div>

                <div className="flex gap-2 mt-5">
                  <svg
                    width="25"
                    height="16"
                    className="mt-1"
                    viewBox="0 0 25 23"
                    fill="none"
                  >
                    <path
                      d="M16.847 14.7553L16.2365 15.3682C16.2365 15.3682 14.7835 16.8239 10.8189 12.849C6.85434 8.87399 8.30735 7.41821 8.30735 7.41821L8.69107 7.03126C9.63962 6.08149 9.72951 4.55536 8.90171 3.44053L7.21122 1.16351C6.18619 -0.2165 4.20725 -0.399148 3.0333 0.77792L0.926893 2.88853C0.345955 3.473 -0.0431262 4.22795 0.00383177 5.06678C0.124581 7.21391 1.08789 11.8315 6.45989 17.219C12.1579 22.9312 17.5044 23.1585 19.69 22.9528C20.3823 22.8879 20.9833 22.5334 21.4677 22.0463L23.3728 20.136C24.6608 18.8466 24.2986 16.6345 22.651 15.7321L20.0884 14.3264C19.0071 13.7351 17.6922 13.9083 16.847 14.7553Z"
                      fill="black"
                    ></path>
                    <path
                      d="M16.847 14.7553L16.2365 15.3682C16.2365 15.3682 14.7835 16.8239 10.8189 12.849C6.85434 8.87399 8.30735 7.41821 8.30735 7.41821L8.69107 7.03126C9.63962 6.08149 9.72951 4.55536 8.90171 3.44053L7.21122 1.16351C6.18619 -0.2165 4.20725 -0.399148 3.0333 0.77792L0.926893 2.88853C0.345955 3.473 -0.0431262 4.22795 0.00383177 5.06678C0.124581 7.21391 1.08789 11.8315 6.45989 17.219C12.1579 22.9312 17.5044 23.1585 19.69 22.9528C20.3823 22.8879 20.9833 22.5334 21.4677 22.0463L23.3728 20.136C24.6608 18.8466 24.2986 16.6345 22.651 15.7321L20.0884 14.3264C19.0071 13.7351 17.6922 13.9083 16.847 14.7553Z"
                      fill="var(--primary-color)"
                    ></path>
                  </svg>
                  <div>
                    <div className="text-primary">Phone</div>
                    <div className="fs-20">
                      <a
                        href="tel:+16592259107"
                        className="native link-text-white"
                      >
                        (+1) 659 225 9107
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex gap-2 mt-5">
                  <svg
                    width="20"
                    height="20"
                    className="mt-1"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10.0025 1.19156e-07C11.5408 0.000534114 13.0582 0.355883 14.4368 1.03841C15.8153 1.72093 17.0179 2.71224 17.9508 3.93521C18.8837 5.15819 19.522 6.57988 19.8158 8.0897C20.1097 9.59951 20.0513 11.1568 19.6451 12.6403C19.2389 14.1239 18.496 15.4938 17.474 16.6434C16.4521 17.7931 15.1787 18.6915 13.7529 19.2688C12.327 19.8462 10.7872 20.0869 9.25323 19.9722C7.71922 19.8574 6.23235 19.3905 4.90827 18.6075L0.824123 19.9675C0.714091 20.004 0.596076 20.0092 0.483268 19.9825C0.37046 19.9558 0.267304 19.8982 0.18533 19.8162C0.103357 19.7343 0.045795 19.6311 0.019079 19.5183C-0.00763703 19.4055 -0.00245466 19.2875 0.0340469 19.1775L1.39543 15.095C0.496162 13.5764 0.0148369 11.8469 0.000337557 10.0821C-0.0141618 8.31738 0.438681 6.58021 1.31287 5.04706C2.18707 3.51391 3.45147 2.23939 4.97767 1.35295C6.50388 0.466514 8.23751 -0.000272284 10.0025 1.19156e-07ZM10.0025 1.25C8.43594 1.24977 6.89804 1.67003 5.54935 2.46692C4.20066 3.26381 3.09064 4.4081 2.33517 5.78033C1.5797 7.15257 1.20648 8.70242 1.25448 10.2681C1.30248 11.8338 1.76993 13.3579 2.60804 14.6812C2.65773 14.7596 2.68935 14.8481 2.70059 14.9402C2.71184 15.0323 2.70243 15.1257 2.67305 15.2137L1.61545 18.3875L4.79076 17.33C4.8786 17.3008 4.97183 17.2915 5.06372 17.3028C5.1556 17.314 5.24384 17.3455 5.32206 17.395C6.46897 18.1203 7.76889 18.569 9.11907 18.7056C10.4692 18.8421 11.8327 18.6628 13.1016 18.1818C14.3706 17.7008 15.5103 16.9313 16.4306 15.9341C17.351 14.937 18.0268 13.7394 18.4046 12.4361C18.7824 11.1328 18.8519 9.75952 18.6076 8.42476C18.3633 7.08999 17.8119 5.83033 16.9969 4.74532C16.1819 3.66031 15.1258 2.7797 13.9119 2.17307C12.6979 1.56645 11.3596 1.25043 10.0025 1.25ZM6.51967 5.005C6.68344 5.005 6.8472 5.005 6.98972 5.01125C7.13973 5.02125 7.34225 4.94875 7.54352 5.465C7.74854 5.99625 8.24109 7.305 8.30234 7.43625C8.36485 7.5675 8.40485 7.72375 8.32485 7.9C8.24234 8.0775 8.19983 8.18875 8.07732 8.34125C7.95481 8.4975 7.8198 8.6875 7.70729 8.805C7.58477 8.93875 7.45601 9.08 7.60103 9.34625C7.74229 9.61 8.23859 10.4812 8.96866 11.1825C9.91 12.0875 10.7013 12.3687 10.9488 12.5C11.1939 12.6325 11.3389 12.6075 11.4802 12.4337C11.6252 12.2587 12.094 11.66 12.259 11.3937C12.4227 11.13 12.5878 11.1712 12.8128 11.2625C13.0378 11.35 14.2492 11.99 14.4942 12.1212C14.7417 12.2562 14.9067 12.3237 14.9667 12.4337C15.0292 12.5462 15.0292 13.0762 14.8255 13.6937C14.6192 14.3137 13.6379 14.88 13.1641 14.9562C12.739 15.0225 12.2015 15.05 11.6127 14.8487C11.1357 14.6883 10.6678 14.5017 10.2113 14.29C7.74229 13.14 6.12963 10.465 6.00712 10.29C5.88336 10.115 5.00203 8.8525 5.00203 7.5475C5.00203 6.245 5.63709 5.6025 5.86211 5.33875C5.94094 5.23885 6.04062 5.15735 6.15418 5.09992C6.26775 5.04249 6.39248 5.00928 6.51967 5.005Z"
                      fill="var(--primary-color)"
                    ></path>
                  </svg>

                  <div>
                    <div className="text-primary">Whatsapp</div>
                    <div className="fs-20">
                      <a
                        href="https://wa.me/16592259107?text=Hi,+can+you+help+me+turn+my+idea+into+something+that+works+for+my business?"
                        className="native link-text-white"
                        target="_blank"
                        rel="noopener"
                      >
                        (+1) 659 225 9107
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="w-full xl:w-2/3  2xl:w-3/5 mt-5 xl:mt-0 px-10"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <form
                ref={formRef}
                noValidate
                onSubmit={handleFormSubmission}
                autoComplete="off"
                spellCheck="false"
                method="post"
              >
                <div className="hh5 mb-10">
                  <span className="opacity-50">1 / Let us get to </span>know you
                </div>

                <div className="flex flex-wrap -mx-5">
                  <div className="w-full xl:w-1/2 form-group px-5">
                    <label>Name *</label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Nic Miller"
                      onBlur={checkValidation}
                      onChange={handleInputChange}
                      value={formData.name}
                      required
                      autoComplete="newpassword"
                      spellCheck="false"
                      aria-labelledby="Name"
                    />
                    <div className="input-border"></div>
                    <div className="input-error">* Name is required</div>
                  </div>

                  <div className="w-full  xl:w-1/2 mt-4 xl:mt-0 form-group px-5">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="nicmiller@company.com"
                      onBlur={checkValidation}
                      onChange={handleInputChange}
                      value={formData.email}
                      autoComplete="newpassword"
                      required
                      aria-labelledby="Email"
                    />
                    <div className="input-border"></div>
                    <div className="input-error">
                      * Provide valid email address
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap -mx-5">
                  <div className="w-full xl:w-1/2 px-5  mt-3 lg:mt-0 lg:mt-0 ">
                    <div className="w-full flex -mx-5 form-group">
                      <div className="px-5">
                        <label id="country-code-label">Country</label>
                        <div
                          className="flex select"
                          onClick={toogleSelect}
                          id="selectCode"
                        >
                          <div className="flags-wrapper">
                            <div className="flags"></div>
                          </div>
                          <input
                            type="text"
                            name="code"
                            onBlur={hideSelectContent}
                            className="code"
                            value={formData.code}
                            readOnly
                            aria-labelledby="country-code-label"
                          />
                          <span></span>
                          <div className="input-border"></div>
                        </div>

                        <div
                          className="custom-select-content"
                          data-lenis-prevent
                        >
                          {countryCodes.map((code, index) => (
                            <div
                              key={index}
                              data-code={code.code}
                              data-number={code.dial_code}
                              data-country={code.name}
                              onClick={handleCodeClick}
                            >
                              <span />
                              {code.name + "  (" + code.dial_code + ")"}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="flex flex-col  w-full relative">
                        <label>Phone Number</label>
                        <input
                          className="phone"
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          placeholder="(+1) 659 225 9107"
                          onChange={handleInputChange}
                          value={formData.phoneNumber}
                          autoComplete="newpassword"
                          spellCheck="false"
                          aria-labelledby="Phone Number"
                        />
                        <div className="input-border"></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full  xl:w-1/2 form-group px-5 mt-8 lg:mt-0 lg:mt-0 ">
                    <label>Website</label>
                    <input
                      type="text"
                      name="website"
                      id="website"
                      placeholder="www.yourcompany.com"
                      value={formData.website}
                      onChange={handleInputChange}
                      aria-labelledby="Website"
                    />
                    <div className="input-border"></div>
                  </div>
                </div>

                <div className="hh5 mb-10 mt-15">
                  <span className="opacity-50">2 / Describe your </span>project
                </div>

                <div className="flex flex-wrap -mx-5 ">
                  <div className="w-full  xl:w-1/2 px-5 form-group">
                    <label>Project Title *</label>
                    <input
                      type="text"
                      name="projectTitle"
                      id="projectTitle"
                      placeholder="e.g Brand Website"
                      onBlur={checkValidation}
                      onChange={handleInputChange}
                      value={formData.projectTitle}
                      required
                      aria-labelledby="Project Title"
                    />
                    <div className="input-border"></div>
                    <div className="input-error">
                      * Project Title is required
                    </div>
                  </div>

                  <div className="w-full  xl:w-1/2 px-5 mt-4 xl:mt-0 form-group required">
                    <label>Project Budget *</label>
                    <div className="flex select" onClick={toogleSelect}>
                      <input
                        type="text"
                        name="projectBudget"
                        id="projectBudget"
                        onBlur={hideSelectContent}
                        onChange={checkValidation}
                        placeholder="Select your estimated budget"
                        value={formData.projectBudget}
                        required
                        readOnly
                      />
                      <span />
                      <div className="input-border"></div>
                      <div className="input-error">
                        * Project Budget is required
                      </div>
                    </div>
                    <div className="custom-select-content" data-lenis-prevent>
                      {budgets.map((budget, index) => (
                        <div
                          key={index}
                          onClick={(e) => {
                            handleSelectClick(e, "projectBudget", budget);
                          }}
                        >
                          <span />
                          {budget}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex -mx-5 flex-wrap mt-4 xl:mt-0">
                  <div className="w-full px-5 xl:w-full form-group">
                    <label>Short Description</label>
                    <input
                      type="text"
                      name="projectDesc"
                      id="projectDesc"
                      placeholder="e.g Highend luxury website"
                      onChange={handleInputChange}
                      value={formData.projectDesc}
                      aria-labelledby="Project Desc"
                    />
                    <div className="input-border"></div>
                  </div>
                </div>

                <div className="flex flex-wrap ">
                  <div className="w-full  xl:w-full form-group mt-10 xl:mt-6">
                    <label>Services Required For Project</label>

                    <div
                      className="flex flex-wrap gap-x-10 gap-y-4 mt-5 "
                      id="services"
                      data-multiple="true"
                    >
                      {props.services.map((service, index) => (
                        <div
                          key={index}
                          className="checkbox"
                          onClick={handleCheckboxEvent}
                        >
                          {service}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="flex mt-20">
                  <div className="xl:w-full form-group">
                    <div
                      className="checkbox"
                      id="notAgreeToTerms"
                      onClick={handleCheckboxEvent}
                    >
                      I agree to send my personal details to receive a proposal.
                    </div>
                    <div className="input-error">
                      * You must accept the term and conditions
                    </div>
                  </div>
                </div>

                <div className="mt-10">
                  <button disabled={true} id="formSubmitBtn">
                    <div>
                      Send Request<i></i>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
